import router from "@/router";

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token');

  // 白名单：登录页、注册页等无需鉴权的路径
  const whiteList = ['/login', '/404', '/500'];

  if (whiteList.includes(to.path)) {
    // 如果是白名单页，直接放行
    return next();
  }

  if (token) {
    // 有 token → 不允许再访问 /login
    if (to.path === '/login') {
      next('/'); // 或 next(from.path || '/dashboard')
    } else {
      next(); // 有 token 且非 login → 放行
    }
  } else {
    // 无 token → 强制跳转登录页
    next('/login');
  }
});